// frontend/src/pages/Businesstype/Businesstype.jsx
import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Briefcase, Plus } from "lucide-react";
import "./Businesstype.css";

// ✅ Backend base URL — same pattern as Banktype.jsx
const url = process.env.REACT_APP_BACKEND_URL;

// ✅ Helper: build auth header from localStorage token
const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const Businesstype = () => {
  const [submitting, setSubmitting] = useState(false);
  const [data, setData] = useState({ name: "" });
  const [focusedFields, setFocusedFields] = useState({ name: false });
  const navigate = useNavigate();

  const handleFocus = (field) =>
    setFocusedFields((prev) => ({ ...prev, [field]: true }));

  const handleBlur = (field) =>
    setFocusedFields((prev) => ({
      ...prev,
      [field]: data[field]?.length > 0,
    }));

  const onChangeHandler = (e) =>
    setData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const onSubmitHandler = async (e) => {
    e.preventDefault();

    if (!data.name) {
      toast.error("Business type name is required");
      return;
    }

    try {
      setSubmitting(true);

      const res = await axios.post(`${url}/api/businesstype`, data, {
        headers: getAuthHeaders(),
      });

      if (res.data.success) {
        toast.success("Business type added successfully!");
        setData({ name: "" });
        navigate("/ViewBusinesstype");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to add Business type");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="form-wrapper">
      <div className="businesstype-form-container">
        <h2 className="form-title">
          <Briefcase size={20} /> Add New Business Type
        </h2>

        <div className="header">
          <h2></h2>
          <button onClick={() => navigate("/ViewBusinesstype")} className="add-button">
            <Plus size={16} /> View Business Types
          </button>
        </div>

        <form className="businesstype-form" onSubmit={onSubmitHandler}>
          <div className={`form-field ${focusedFields.name || data.name ? "filled" : ""}`}>
            <input
              type="text"
              name="name"
              value={data.name}
              onChange={onChangeHandler}
              onFocus={() => handleFocus("name")}
              onBlur={() => handleBlur("name")}
              placeholder="Enter business type (e.g., Retail, Manufacturing)"
              required
            />
            <label>Business Type Name *</label>
          </div>

          <div className="form-info">
            <small>
              Business type will be available for all companies in the system.
              Make sure the name is unique.
            </small>
          </div>

          <button 
            type="submit" 
            className="submit-btn" 
            disabled={submitting}
          >
            {submitting ? "Processing..." : "Add Business Type"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Businesstype;